<template>
  <store-recherche-provider
    :name="storeName"
    :copy="produitStore"
    :copyChanges="changesStore()">
    <liste-ajout-produits :storeName="storeName"/>
  </store-recherche-provider>
</template>

<script>
import getLogo from '@/services/general/getLogo';
import StoreRechercheProvider from '@/components/general/store/storeRechercheProvider';
import ListeAjoutProduits from '@/components/presse/regroupementProduit/produits/listeAjoutProduitsSurRegroupement';
import genererCritereRecherche from '@/services/catalogue/genererCriteresRecherche/genererCritereRechercheProduitsSurRegroupement';
import produitStore from '@/store/modules/produit';
import * as allTypes from '@/store/mutation-type';
import {
  SET_CRITERE_RECHERCHE,
  CLEAR_PANIER,
  ADD_LIGNE_IN_PANIER_AT_END,
  SET_PANIER,
  DELETE_LIGNE_IN_PANIER,
  SET_LOGO,
} from '@/store/modules/produit-mutation-type';

export default {
  name: 'MAjouteProduitsSurRegroupement',
  components: {
    ListeAjoutProduits,
    StoreRechercheProvider,
  },
  data() {
    return {
      produitStore,
      storeName: 'produitSurRegroupement',
    };
  },
  methods: {
    changesStore() {
      const initialState = () => ({
        ...produitStore.state,
        criteresRecherche: genererCritereRecherche(),
        panier: [],
      });
      return {
        state: initialState(),
        mutations: {
          [SET_CRITERE_RECHERCHE]: (state, critereRecherche) => {
            state.criteresRecherche = critereRecherche;
          },
          [allTypes.RESET_STATE]: (state) => {
            const s = initialState();
            Object.keys(state).forEach(key => {
              state[key] = s[key];
            });
          },
          [CLEAR_PANIER](state) {
            state.panier = initialState().panier;
          },
          [ADD_LIGNE_IN_PANIER_AT_END](state, ligne) {
            state.panier.unshift(ligne);
          },
          [SET_PANIER](state, panier) {
            state.panier = panier;
          },
          [DELETE_LIGNE_IN_PANIER](state, deleteObject) {
            const panierWithLigneToDelete = state.panier.filter((ligne) => {
              return ligne.isAlreadySelect === deleteObject.isAlreadySelect;
            });
            panierWithLigneToDelete.splice(deleteObject.index, 1);
            const panierWithoutLigneToDelete = state.panier.filter((ligne) => {
              return ligne.isAlreadySelect === !deleteObject.isAlreadySelect;
            });
            const panier = panierWithLigneToDelete.concat(panierWithoutLigneToDelete);
            state.panier = panier;
          },
          [SET_LOGO](state, item) {
            const produit = state.panier.find((ligne) => {
              return item.produitId === ligne.produit.id && ligne.logo === undefined;
            });
            if (produit) produit.logo = item.logo ? item.logo : '';
          },
        },
        actions: {
          async loadLogoPanier({ commit, getters }) {
            const promises = getters.panier.filter((p) => !p.logo).map(async (p) => {
              const logo = await getLogo(p.produit.id);
              commit(SET_LOGO, {
                logo,
                produitId: p.produit.id,
              });
            });
            await Promise.all(promises);
          },
        },
        getters: {
          criteresRecherche: (state) => state.criteresRecherche,
          panier: (state) => state.panier,
        },
      };
    },
  },
};
</script>
